import * as Flags from 'country-flag-icons/react/3x2';

/**
 * Cross-platform country flag. Renders a bundled SVG (via `country-flag-icons`)
 * instead of a flag emoji, because Windows/Chrome ships no regional-indicator
 * flag glyphs and would otherwise show bare letter pairs (e.g. "ES").
 *
 * `code` is a 2-letter country code (e.g. "BE", "ES"); "UK" is normalised to
 * "GB". Unknown/empty codes fall back to a neutral white-flag glyph so the row
 * still lines up. Sizing/alignment matches the old emoji placement
 * (`text-base leading-none` → ~1rem tall, inline-block).
 */
const FIX = { UK: 'GB' };

export default function Flag({ code, className = '', title }) {
  const cc = code ? (FIX[code.toUpperCase()] || code).toUpperCase().slice(0, 2) : '';
  const Svg = /^[A-Z]{2}$/.test(cc) ? Flags[cc] : null;
  if (!Svg) {
    return (
      <span className={`inline-block leading-none ${className}`} aria-hidden title={title}>
        🏳️
      </span>
    );
  }
  return (
    <Svg
      title={title || cc}
      className={`inline-block h-[1em] w-auto shrink-0 rounded-[1px] align-[-0.125em] ${className}`}
    />
  );
}
